import type { IconSvgObject } from './types';

const LeftToRightListStar01Icon: IconSvgObject = [
  ["path", { d: "M3 5.5L12.5 5.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 12L12.5 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 18.5L12.5 18.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 18.5L16 18.5M17 21L20 16M20 21L17 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M21 5.5L16 5.5M17 8L20 3M20 8L17 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LeftToRightListStar01Icon;
